module.exports = __webpack_public_path__ + "img/hero-mobile.3999e132.webp";